module.exports = __webpack_public_path__ + "static/media/Alarm.dc801bc8.svg";